import { Box, Flex, Text } from "@chakra-ui/react";
import { ManagerVerificationStatusEnumType } from "@verivest/shared-components/src/api/enums";
import { ManagerLabel } from "@verivest/shared-components/src/components/common/managers/ManagerLabel";
import { VerifiedIcon } from "@verivest/shared-components/src/components/common/VerifiedIcon";
import React from "react";
import { HCardWithImage } from "./HCardWithImage";
import { InvestmentCardProps } from "./horizontal-cards.types";
import { cn } from "@verivest/shared-components/src/utils/css";

export const InvestmentCard: React.FC<InvestmentCardProps> = ({
  actions,
  imageHoverTopLeft,
  imageHoverBottomLeft,
  children,
  header,
  manager,
  imageUrl,
  showManagerLabel,
  ...rest
}) => {
  return (
    <HCardWithImage
      manager={manager}
      imageHoverTopLeft={imageHoverTopLeft}
      imageHoverBottomLeft={imageHoverBottomLeft}
      imageUrl={imageUrl}
      {...rest}
    >
      <Box className={cn(!showManagerLabel ? "sm:ml-4" : "ml-0")}>
        <Flex className={"flex-col sm:flex-row sm:justify-between"}>
          <Box>
            <Text fontSize="lg" fontWeight="bold">
              {header}
            </Text>
          </Box>
          <Flex className={"gap-1 mt-2 sm:mt-0"}>{actions}</Flex>
        </Flex>
        <Flex mt={4} alignContent="end" alignItems="end">
          {showManagerLabel && manager && (
            <Flex maxWidth="55%" minWidth="30%" alignItems="center" gap={1}>
              <ManagerLabel manager={manager} />
              <VerifiedIcon
                notVerified={
                  manager.verificationStatus !==
                  ManagerVerificationStatusEnumType.Verified
                }
              />
            </Flex>
          )}
          <Box display={"inline-block"}>{children}</Box>
        </Flex>
      </Box>
    </HCardWithImage>
  );
};
